import { APP_MEMBERSHIP_CHECKOUT_ROUTE } from '@membership/subscription-mobility/navigation/urls';

export { APP_MEMBERSHIP_CHECKOUT_ROUTE };
export const APP_MEMBERSHIP_PAID_TRAFFIC_CHECKOUT_ROUTE = '/app-membership/tiers';
export const APP_MEMBERSHIP_EMAIL_VERIFICATION_ROUTE =
  '/app-membership/app-free/email-verification';
export const DOWNLOAD_APP_ROUTE = '/download/app';
